import "./Card.scss"

const Card = ({ content }) => {
  return (
    <div>
      <div
        className="tips-card"
        style={{
          backgroundImage: `url(${content.background})`,
        }}
      >
        <div className="tips-card__content">
          <h3 className="tips-card__category">{content.category}</h3>

          <a href={content.link} className="tips-card__title" target="__blank">
            {content.title}
          </a>
        </div>
      </div>
    </div>
  )
}

export default Card
